export default "/fonts/vendor/devextreme/dist/css/icons/dxicons.woff?d5288d8f61ece0a2f2ab745dc44c600b";